const mergeCapabilities = (existing = {}, incoming = {}) => {
	if (!incoming || typeof incoming !== 'object') {
		return existing;
	}
	const merged = {
		...existing,
		...incoming,
	};
	if (incoming.deposit) {
		merged.deposit = {
			...existing.deposit,
			...incoming.deposit,
		};
	}
	if (incoming.refund) {
		const existingBreakdown = existing.refund?.breakdown || {};
		const incomingBreakdown = incoming.refund?.breakdown || {};
		merged.refund = {
			...existing.refund,
			...incoming.refund,
			breakdown: {
				...existingBreakdown,
				...incomingBreakdown,
				deposit: {
					...existingBreakdown.deposit,
					...incomingBreakdown.deposit,
				},
				final: {
					...existingBreakdown.final,
					...incomingBreakdown.final,
				},
			},
		};
	}
	return merged;
};

export const bidRealtimePatch = (message) => {
	const patch = {
		status: message.status,
		amount: message.amount,
		approved_at: message.approved_at,
		rejected_at: message.rejected_at,
	};
	if (message.capabilities) {
		patch.capabilities = message.capabilities;
	}
	return patch;
};

export const mergeBidDetailsFromRealtime = (bidDetails, message) => {
	if (!bidDetails) {
		return bidDetails;
	}
	const patch = bidRealtimePatch(message);
	const next = {
		...bidDetails,
		...patch,
	};
	if (message.capabilities) {
		next.capabilities = mergeCapabilities(
			bidDetails.capabilities,
			message.capabilities,
		);
	}
	return next;
};

export const applyBidRealtimeToJobList = (jobs, message) => {
	if (message?.type !== 'bid.updated' || !message.job_id) {
		return jobs;
	}
	return jobs.map((job) =>
		String(job.id) === String(message.job_id)
			? {
					...job,
					bid_status: message.status,
					bid_amount: message.amount,
					...(message.deposit_paid_amount != null
						? { deposit_paid_amount: message.deposit_paid_amount }
						: {}),
					...(message.refunded_amount != null
						? { refunded_amount: message.refunded_amount }
						: {}),
					...(message.refund_summary
						? { refund_summary: message.refund_summary }
						: {}),
				}
			: job,
	);
};

export const applyBidRealtimeToJobDetail = (job, message) => {
	if (
		message?.type !== 'bid.updated' ||
		!job ||
		String(message.job_id) !== String(job.id)
	) {
		return job;
	}
	const updatedBidDetails =
		String(job.bid_details?.id) === String(message.bid_id)
			? mergeBidDetailsFromRealtime(job.bid_details, message)
			: job.bid_details;
	const updatedBids = (job.bids || []).map((bid) =>
		String(bid.id) === String(message.bid_id)
			? mergeBidDetailsFromRealtime(bid, message)
			: bid,
	);
	return {
		...job,
		bid_details: updatedBidDetails,
		bids: updatedBids,
		bid_status: message.status,
		bid_amount: message.amount,
		...(message.deposit_paid_amount != null
			? { deposit_paid_amount: message.deposit_paid_amount }
			: {}),
		...(message.refunded_amount != null
			? { refunded_amount: message.refunded_amount }
			: {}),
		...(message.refund_summary
			? { refund_summary: message.refund_summary }
			: {}),
	};
};
